const getCountry = async (lat, lng) => {
    try {
        const url = `https://api.maptiler.com/geocoding/${lng},${lat}.json?KEY=${process.env.REACT_APP_TICINO_MAP_TILER_KEY}`;
        const response = await fetch(url);
        
        if(!response.ok) {
            throw new Error('Fetch error: chiamata fallita.')
        }
        const cityData = await response.json();
        return cityData.features[0].place_name_it ? cityData.features[0].place_name_it : cityData.features[0].place_name;
    } catch (error) {
        console.error('Catch error: ', error)
    }
}

export default getCountry